import { render, staticRenderFns } from "./FeedbackView.vue?vue&type=template&id=002c77c7&"
import script from "./FeedbackView.vue?vue&type=script&lang=js&"
export * from "./FeedbackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports